import { formatStripeAmount } from "@bounce/i18n"

import type { CityData } from "../../../../libs/bounce/cities/types"
import type { FormattedEvent } from "../../../../libs/prismic/event/types"
import { defaultPricing } from "../../../../utils/pricing"

export type BaseEventInterpolations = {
  PRICE: string
  LOWEST_PRICE: string
  EVENT_NAME: string
  INSURANCE_AMOUNT: string
  NUM_BAGS_STORED: string
  NUM_CITIES: string
  NUM_LOCATIONS: string
  CITY_NAME: string
  YEAR: string
  CITY_MAIN_STORE_LOCATION: string
}

type GetBaseEventInterpolationsOptions = {
  event: FormattedEvent
  city: CityData
  language: string
  bounceGlobals: {
    bounceShieldProtection: string
    numLocations: string
    numCities: string
    numBagsStored: string
  }
  currency: string
}

export const getBaseEventInterpolations = ({
  event,
  city,
  language,
  bounceGlobals,
  currency,
}: GetBaseEventInterpolationsOptions): BaseEventInterpolations => {
  const { defaultLowestLuggagePrice } = defaultPricing
  const lowestLuggagePrice = city.lowestPrice || defaultLowestLuggagePrice
  const lowestPrice = formatStripeAmount(lowestLuggagePrice, currency, language)

  return {
    PRICE: lowestPrice,
    LOWEST_PRICE: lowestPrice,
    EVENT_NAME: event.name,
    INSURANCE_AMOUNT: bounceGlobals.bounceShieldProtection,
    NUM_BAGS_STORED: bounceGlobals.numBagsStored,
    NUM_CITIES: bounceGlobals.numCities,
    NUM_LOCATIONS: bounceGlobals.numLocations,
    CITY_NAME: city.translatedName || "",
    YEAR: new Date().getFullYear().toString(),
    CITY_MAIN_STORE_LOCATION: city.mainStore?.gmbAddress?.addressLines || city.translatedName || "",
  }
}
